export default __webpack_public_path__ + "icon_map_pin_filled.efe8e7e1965ac792d6d0413f123cf62c.svg";